export default function ItemEntry({children, props}) {
  return (
    <>
      <div className="section-header">
        <h3>
          {children}
        </h3>
      </div>
    </>
  )
}